import React from 'react';
import { DomainEntityCard } from '../domainEntityTable';

export function LocationsCard(props: {targeturl: string}) {
    return <DomainEntityCard {...props} title="Locations" type="location"/>
}

export default LocationsCard;
